export enum LabType {
  NEONATAL = 'neonatal',
}

export const labTypeName: Record<LabType, string> = {
  [LabType.NEONATAL]: 'Neonatal Labs',
}

export type LabSectionType =
  | 'cord-blood-banking'
  | 'cord-blood-gases'
  | 'pku-screen'
  | 'additional-labs'

export interface CordBloodBankingSection {
  type: 'cord-blood-banking'
}

export interface CordBloodGasesSection {
  type: 'cord-blood-gases'
}

export interface PKUScreenSection {
  type: 'pku-screen'
}

export interface AdditionalLabsSection {
  type: 'additional-labs'
}

export type LabSection =
  | CordBloodBankingSection
  | CordBloodGasesSection
  | PKUScreenSection
  | AdditionalLabsSection

export interface CordBloodBankingData {
  bankingDecision?: 'yes' | 'no' | 'declined'
  collectionKitPresent?: boolean
  collectionPerformed?: 'yes' | 'no'
  collectionNotPerformedReason?: string
  bankingCompanyName?: string
  collectionTime?: string
  chainOfCustodyConfirmation?: boolean
}

export interface CordBloodGasesData {
  indication?: string
  sampleType?: 'arterial' | 'venous' | 'both'
  ph?: number
  pco2?: number
  po2?: number
  baseExcess?: number
  bicarbonate?: number
  labReviewed?: boolean
}

export interface PKUScreenResultData {
  result?: string
  receivedDate?: number
  abnormal?: boolean
}

export interface PKUScreenData {
  newbornScreenOrdered?: boolean
  orderedDate?: number
  collectionDateTime?: number
  screenKitId?: string
  resultsReceived?: PKUScreenResultData
  abnormalFollowUp?: string
}

export interface AdditionalLabItem {
  labName?: string
  result?: string
  date?: number
  reviewed?: boolean
}

export interface NeonatalLabData {
  cordBloodBanking?: CordBloodBankingData
  cordBloodGases?: CordBloodGasesData
  pkuScreen?: PKUScreenData
  additionalLabs?: AdditionalLabItem[]
}

export type LabData<T extends LabType> = {
  [LabType.NEONATAL]: NeonatalLabData
}[T]
